import React from 'react';

import { TranslatedMessage } from 'common/components/Intl';

import { AgeGateContext } from 'apps/age_gate/ageGateContext';

function getLink(translationMessages, inputUrl, inputLinkText) {
  const urlMessage = translationMessages[inputUrl];
  const linkTextMessage = translationMessages[inputLinkText];

  return <a href={urlMessage}>{linkTextMessage}</a>;
}

export const TranslatedLinkMessage = ({ id, link, linkText, inlineData }) => {
  const { messageKeys, translationMessages } = React.useContext(AgeGateContext);

  return (
    <TranslatedMessage
      id={messageKeys[id]}
      values={Object.assign(
        {
          link_text: getLink(
            translationMessages,
            messageKeys[link],
            messageKeys[linkText]
          ),
        },
        inlineData
      )}
    />
  );
};
